<div  class="row p-5 padding-bet">
  <div [innerHTML]="componentData.content" class="component col-12"></div>
</div>
